/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObjectNames} from 'types/diplomat-object';
import {DiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {AdminResourceTypeSchema} from './AdminResourceType';
import {RoleNames} from '../RoleNames';

export const AdminRole = DiplomatObject.shape({
   immutable: yup.boolean(),
   resources: yup.array().of(AdminResourceTypeSchema),
   overwrite: yup.bool(),
   [DiplomatObjectNames.objectType]: yup
      .string()
      .oneOf(DiplomatObjectType.keys)
      .default(DiplomatObjectType.enum.ADMIN_ROLE),

   [RoleNames.includeLdapUsers]: yup.boolean(),
   [RoleNames.ldapGroupFilter]: yup.string(),
});
export type IAdminRole = yup.InferType<typeof AdminRole>;
